export enum Nivel{
    LIGA = 'LIGA',
    NOVATO = 'NOVATO',
    ESCUELA = 'ESCUELA',
    NA = "N/A"
}